import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import ModalFrame from './ModalFrame';
export function useModalFrame({
  src,
  onMessage,
  renderLoadingModal,
  id
}) {
  const rootRef = useRef(document.createElement('div'));
  const [loadFrame, setLoadFrame] = useState(false);
  useEffect(() => {
    if (loadFrame) {
      const currentRootRef = rootRef.current;
      document.body.appendChild(currentRootRef);
      ReactDOM.render( /*#__PURE__*/_jsx(ModalFrame, {
        id: id,
        setLoadFrame: setLoadFrame,
        src: src,
        onMessage: onMessage,
        renderLoadingModal: renderLoadingModal
      }), currentRootRef);
      return () => {
        ReactDOM.unmountComponentAtNode(currentRootRef);
        document.body.removeChild(currentRootRef);
      };
    }

    return () => {};
  }, [src, loadFrame, onMessage, renderLoadingModal, id]);
  return {
    setLoadFrame
  };
}